"use strict";

var _regeneratorRuntime = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBestProvider = void 0;
/**
 * @param providers - An array of providers to try to connect to.
 * @param timeout - How long to wait before a call is considered failed, in ms.
 */

function getBestProvider(providers) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(providers.length === 1)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", providers[0]);

          case 2:
            return _context.abrupt("return", new Promise(function (resolve) {
              var resolved = false;
              var successes = {};
              providers.forEach(function (provider, i) {
                // create a promise that resolves on a successful call, and rejects on a failed call or after timeout milliseconds
                var promise = new Promise(function (resolve, reject) {
                  provider.getNetwork().then(function () {
                    return resolve();
                  }).catch(function () {
                    return reject();
                  }); // set a timeout to reject

                  // set a timeout to reject
                  setTimeout(function () {
                    reject();
                  }, timeout);
                });
                void promise.then(function () {
                  return true;
                }).catch(function () {
                  return false;
                }).then(function (success) {
                  // if we already resolved, return
                  if (resolved) return; // store the result of the call

                  // store the result of the call
                  successes[i] = success; // if this is the last call and we haven't resolved yet - do so

                  // if this is the last call and we haven't resolved yet - do so
                  if (Object.keys(successes).length === providers.length) {
                    var index = Object.keys(successes).findIndex(function (j) {
                      return successes[Number(j)];
                    }); // no need to set resolved to true, as this is the last promise

                    // no need to set resolved to true, as this is the last promise
                    return resolve(providers[index === -1 ? 0 : index]);
                  } // otherwise, for each prospective index, check if we can resolve


                  // otherwise, for each prospective index, check if we can resolve
                  new Array(providers.length).fill(0).forEach(function (_, prospectiveIndex) {
                    // to resolve, we need to:
                    // a) have successfully made a call
                    // b) not be waiting on any other higher-index calls
                    if (successes[prospectiveIndex] && new Array(prospectiveIndex).fill(0).every(function (_, j) {
                      return successes[j] === false;
                    })) {
                      resolved = true;
                      resolve(providers[prospectiveIndex]);
                    }
                  });
                });
              });
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.getBestProvider = getBestProvider;